import { Toast } from "primereact/toast";
import { useRef } from "react";
import { Table } from "./Table";

export const ResumeSearchConsultant = () => {
    const toast = useRef<any>(null);
    return (
        <>
            <Table toast={toast} />
            <Toast ref={toast} />
        </>
    );
};